import React from "react"
import { FaBold, FaItalic, FaStrikethrough, FaUnderline } from "react-icons/fa"

import classes from "./EditorTextDecoration.module.scss"
import clsx from "clsx"

const EditorTextDecoration = (props) => {
  const { editor } = props

  return (
    <div className={classes["container"]}>
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={clsx(
          classes["button"],
          editor.isActive("bold") && classes["active"]
        )}
      >
        <FaBold />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        className={clsx(
          classes["button"],
          editor.isActive("italic") && classes["active"]
        )}
      >
        <FaItalic />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleStrike().run()}
        className={clsx(
          classes["button"],
          editor.isActive("strike") && classes["active"]
        )}
      >
        <FaStrikethrough />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        className={clsx(
          classes["button"],
          editor.isActive("underline") && classes["active"]
        )}
      >
        <FaUnderline />
      </button>
    </div>
  )
}

export default EditorTextDecoration